import { useMutation } from "react-query";
import { MedicalExaminationService } from "@services/medical-examination.service";

export const useUpdateMedicalExamControlsMutation = () => {
  return useMutation(MedicalExaminationService.updateControls);
};
